"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BonusTournamentLocalesListCtl = /** @class */ (function (_super) {
    __extends(BonusTournamentLocalesListCtl, _super);
    function BonusTournamentLocalesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_app_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_app_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_description_tpl = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description_tpl; });
        _this.dk_bonus_template_json_test_data = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_json_test_data; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTournamentLocalesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BonusTournamentLocalesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "bonus template locale with id [" + id + "] not found !";
    };
    BonusTournamentLocalesListCtl.prototype.LoadData = function (bonusTournamentId, onDone) {
        var _this = this;
        webAApi_1.ListTournamentLocalesByTournamentIdGet.exec({
            bonus_tournament_id: bonusTournamentId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    title: resp.list[i].title,
                    description_tpl: resp.list[i].description_tpl,
                    bonus_template_json_test_data: resp.list[i].bonus_template_json_test_data,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentLocalesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddTournamentLocale.exec({
            data: {
                bonus_tournament_id: data.bonus_tournament_id,
                app_language_id: data.app_language_id,
                title: data.title
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                app_language_id: data.app_language_id,
                app_language_title: resp.app_language_title,
                title: data.title,
                description_tpl: resp.description_tpl,
                bonus_template_json_test_data: resp.bonus_template_json_test_data,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentLocalesListCtl.prototype.DoUpdateDescriptionTpl = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoUpdateBonusTournamentLocaleDescriptionTpl.exec({
                data: {
                    bonus_tournament_locale_id: data.key,
                    description_tpl: data.template,
                }
            }, function (resp) {
                _tmp.description_tpl = data.template;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTournamentLocalesListCtl.prototype.DoRenderTemplatePreview = function (data, onDone) {
        var _this = this;
        webAApi_1.DoRenderTournamentLocalePreview.exec({
            data: {
                tpl_text: data.template,
                json_data: data.data,
            }
        }, function (resp) {
            if (onDone) {
                onDone(resp.rendered_txt);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentLocalesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditTournamentLocale.exec({
                data: {
                    bonus_tournament_locale_id: data.key,
                    app_language_id: data.app_language_id,
                    title: data.title
                }
            }, function (resp) {
                _tmp.app_language_id = data.app_language_id;
                _tmp.app_language_title = resp.app_language_title;
                _tmp.title = data.title;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTournamentLocalesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusTournamentLocalesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteTournamentLocale.exec({ data: { bonus_tournament_locale_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusTournamentLocalesListCtl;
}(BaseController_1.BaseController));
exports.BonusTournamentLocalesListCtl = BonusTournamentLocalesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ctl/options/BonusTournamentsLocalesListCtl.ts
// module id = 1020
// module chunks = 0